import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.korslovo.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-page-korslovo-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.korslovo.mypage/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: hidden;
}`],
})
export class PageKorslovoMypageComponent implements OnInit {
    public ru = RU;
    public profile: any = {};
    public stats: any = {};
    public lessonProgress: any[] = [];  // category groups
    public expandedCategories: Set<string> = new Set();
    public showLessonProgress: boolean = false;

    public showPasswordForm: boolean = false;
    public currentPassword: string = '';
    public newPassword: string = '';
    public newPasswordConfirm: string = '';
    public passwordError: string = '';
    public passwordSuccess: boolean = false;

    public editingName: boolean = false;
    public editName: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadProfile();
        await this.service.render();
    }

    public async loadProfile() {
        const res = await wiz.call("profile");
        if (res.code === 200) {
            this.profile = res.data.profile || {};
            this.stats = res.data.stats || {};
            this.lessonProgress = res.data.lesson_progress || [];
        }
    }

    public getLevelLabel(level: string): string {
        if (level === 'beginner') return RU.auth_level_beginner;
        if (level === 'elementary') return RU.auth_level_elementary;
        return level || '-';
    }

    public statusLabel(status: string): string {
        if (status === 'completed') return RU.lesson_completed;
        if (status === 'in_progress') return RU.lesson_in_progress;
        return RU.lesson_not_started;
    }

    public statusColor(status: string): string {
        if (status === 'completed') return 'text-emerald-600 bg-emerald-50';
        if (status === 'in_progress') return 'text-blue-600 bg-blue-50';
        return 'text-zinc-400 bg-zinc-50';
    }

    public overallProgress(): { completed: number; total: number; percent: number } {
        let completed = 0;
        let total = 0;
        for (const cat of this.lessonProgress) {
            const lessons = cat.lessons || [];
            total += lessons.length;
            completed += lessons.filter((l: any) => l.status === 'completed').length;
        }
        const percent = total > 0 ? Math.round(completed / total * 100) : 0;
        return { completed, total, percent };
    }

    public async toggleLessonProgress() {
        this.showLessonProgress = !this.showLessonProgress;
        if (this.showLessonProgress && this.expandedCategories.size === 0) {
            // 처음 펼칠 때 모든 카테고리 열기
            for (const cat of this.lessonProgress) {
                this.expandedCategories.add(cat.category_id);
            }
        }
        await this.service.render();
    }

    public async toggleCategory(catId: string) {
        if (this.expandedCategories.has(catId)) {
            this.expandedCategories.delete(catId);
        } else {
            this.expandedCategories.add(catId);
        }
        await this.service.render();
    }

    public isCategoryExpanded(catId: string): boolean {
        return this.expandedCategories.has(catId);
    }

    public categoryProgress(cat: any): { completed: number; total: number; percent: number } {
        const lessons = cat.lessons || [];
        const total = lessons.length;
        const completed = lessons.filter((l: any) => l.status === 'completed').length;
        const percent = total > 0 ? Math.round(completed / total * 100) : 0;
        return { completed, total, percent };
    }

    public lessonPercent(lesson: any): number {
        if (lesson.status === 'completed') return 100;
        if (lesson.status !== 'in_progress' || !lesson.word_count) return 0;
        return Math.min(99, Math.round((lesson.card_index / lesson.word_count) * 100));
    }

    public statusIcon(status: string): string {
        if (status === 'completed') return '✓';
        if (status === 'in_progress') return '▶';
        return '';
    }

    public async startEditName() {
        this.editName = this.profile.name || '';
        this.editingName = true;
        await this.service.render();
    }

    public async cancelEditName() {
        this.editingName = false;
        await this.service.render();
    }

    public async saveName() {
        if (!this.editName.trim()) return;
        const res = await wiz.call("update_name", { name: this.editName.trim() });
        if (res.code === 200) {
            this.profile.name = this.editName.trim();
            this.editingName = false;
        }
        await this.service.render();
    }

    public async togglePasswordForm() {
        this.showPasswordForm = !this.showPasswordForm;
        this.currentPassword = '';
        this.newPassword = '';
        this.newPasswordConfirm = '';
        this.passwordError = '';
        this.passwordSuccess = false;
        await this.service.render();
    }

    public async changePassword() {
        this.passwordError = '';
        this.passwordSuccess = false;

        if (!this.currentPassword || !this.newPassword) {
            this.passwordError = RU.auth_error_password;
            await this.service.render();
            return;
        }
        if (this.newPassword !== this.newPasswordConfirm) {
            this.passwordError = RU.auth_error_password_match;
            await this.service.render();
            return;
        }
        if (this.newPassword.length < 6) {
            this.passwordError = RU.mypage_min_password;
            await this.service.render();
            return;
        }

        const res = await wiz.call("change_password", {
            current_password: this.currentPassword,
            new_password: this.newPassword
        });

        if (res.code === 200) {
            this.passwordSuccess = true;
            this.currentPassword = '';
            this.newPassword = '';
            this.newPasswordConfirm = '';
        } else {
            this.passwordError = res.data?.message || RU.error;
        }
        await this.service.render();
    }

    public async logout() {
        await wiz.call("logout");
        location.href = '/access';
    }
}

export default PageKorslovoMypageComponent;